import { tns } from "tiny-slider/src/tiny-slider";

if ($(".application__img-silder").length > 0) {
  let imgSlider = tns({
    container: ".application__img-silder",
    items: 1,
    nav: false,
    loop: false,
    speed: 1200,
    controlsContainer: ".application__btns",
  });
}

if ($(".application__text-silder").length > 0) {
  let textSlider = tns({
    container: ".application__text-silder",
    items: 1,
    nav: false,
    loop: false,
    speed: 1200,
    controlsContainer: ".application__btns",
  });

  const info = textSlider.getInfo(),
    count = info.slideCount,
    index = info.displayIndex;
  $(".application__item-numbers").html("0" + count);
  $(".application__current-number").html("0" + index);

  $(".application__btn--next").on("click", function () {
    const info = textSlider.getInfo(),
      index = info.displayIndex;
    $(".application__current-number").html("0" + (index + 1));
  });

  $(".application__btn--prev").on("click", function () {
    const info = textSlider.getInfo(),
      index = info.displayIndex;
    $(".application__current-number").html("0" + (index - 1));
  });
}

if ($(".opinion-application__img-silder").length > 0) {
  let imgSlider = tns({
    container: ".opinion-application__img-silder",
    items: 1,
    nav: false,
    loop: false,
    speed: 1200,
    controlsContainer: ".opinion-application__btns",
  });
}

if ($(".opinion-application__text-silder").length > 0) {
  let textSlider = tns({
    container: ".opinion-application__text-silder",
    items: 1,
    nav: false,
    loop: false,
    speed: 1200,
    controlsContainer: ".opinion-application__btns",
  });

  const info = textSlider.getInfo(),
    count = info.slideCount,
    index = info.displayIndex;
  $(".opinion-application__item-numbers").html("0" + count);
  $(".opinion-application__current-number").html("0" + index);

  $(".opinion-application__btn--next").on("click", function () {
    const info = textSlider.getInfo(),
      index = info.displayIndex;
    $(".opinion-application__current-number").html("0" + (index + 1));
  });

  $(".opinion-application__btn--prev").on("click", function () {
    const info = textSlider.getInfo(),
      index = info.displayIndex;
    $(".opinion-application__current-number").html("0" + (index - 1));
  });
}
